export default __webpack_public_path__ + "static/media/actions-avalanche.1bd56486.svg";